import * as React from "react";

import { UNIT_MENU_VISIBLE_BUTTON_CLICK } from "../../../metricsAction";
import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { MenuAction } from "../../EmbeddedLog/MenuAction/MenuAction";

export interface HideUnitButtonProps {
    hasEmptyUnit: boolean;
    emptyUnitsVisible: boolean;
    isReadOnly?: boolean;
    onChangeEmptyUnitsVisible: (isVisible: boolean) => void;
    children?: React.ReactNode;
}

export function HideUnitButton(props: HideUnitButtonProps): JSX.Element {
    const track = useMetrics();

    const handleClick = () => {
        track(UNIT_MENU_VISIBLE_BUTTON_CLICK, { action: props.emptyUnitsVisible ? "hideUnits" : "showUnits" });
        props.onChangeEmptyUnitsVisible(!props.emptyUnitsVisible);
    };

    if (props.isReadOnly) {
        return <></>;
    }

    if (props.hasEmptyUnit) {
        return (
            <MenuAction
                icon={props.emptyUnitsVisible ? "EyeOffIcon" : "EyeOpenIcon"}
                text={props.emptyUnitsVisible ? "Скрыть пустые разделы" : "Показать пустые разделы"}
                onClick={handleClick}
            />
        );
    }

    return <></>;
}
